// Icons
import AboutPeople from "../assets/Icons/about-people.svg";
import AmericanExpressLogo from "../assets/Icons/american-express-logo.svg";
import Animals from "../assets/Icons/animals.svg";
import ArrowUpRight from "../assets/Icons/arrow-up-right.svg";
import Box from "../assets/Icons/box.svg";
import CallMIcon from "../assets/Icons/call-MIcon.svg";
import Children from "../assets/Icons/children.svg";
import ContactusFormElement from "../assets/Icons/contactus-form-element.svg";
import CreditCard from "../assets/Icons/credit-card.svg";
import Disability from "../assets/Icons/disability.svg";
import DisasterRelief from "../assets/Icons/disaster-relief.svg";
import Diy from "../assets/Icons/diy.svg";
import Edit from "../assets/Icons/edit.svg";
import Education from "../assets/Icons/education.svg";
import Elderly from "../assets/Icons/elderly.svg";
import ExploreMIcon from "../assets/Icons/explore-MIcon.svg";
import EyeSlash from "../assets/Icons/eye-slash.svg";
import Facebook from "../assets/Icons/facebook.svg";
import Faith from "../assets/Icons/faith.svg";
import FooterFacebook from "../assets/Icons/footer-facebook.svg";
import FooterInstagram from "../assets/Icons/footer-instagram.svg";
import FooterLinkedin from "../assets/Icons/footer-linkedin.svg";
import FooterTwitter from "../assets/Icons/footer-twitter.svg";
import Gps from "../assets/Icons/gps.svg";
import GreenRupee from "../assets/Icons/green-rupee.svg";
import HealthInsuranceMIcon from "../assets/Icons/health-insurance-MIcon.svg";
import HeartMIcon from "../assets/Icons/heart-MIcon.svg";
import HomeMIcon from "../assets/Icons/home-MIcon.svg";
import HospitalGrey from "../assets/Icons/hospital-grey.svg";
import Hospital from "../assets/Icons/hospital.svg";
import Hunger from "../assets/Icons/hunger.svg";
import InfoCircleMIcon from "../assets/Icons/info-circle-MIcon.svg";
import Layer from "../assets/Icons/layer.svg";
import LeftArrow from "../assets/Icons/left-arrow.svg";
import LeftDoubleArrow from "../assets/Icons/left-double-arrow.svg";
import Linkedin from "../assets/Icons/linkedin.svg";
import LoginMIcon from "../assets/Icons/login-MIcon.svg";
import LogoutMIcon from "../assets/Icons/logout-MIcon.svg";
import Mail from "../assets/Icons/mail.svg";
import MastercardLogo from "../assets/Icons/mastercard-logo.svg";
import Medical from "../assets/Icons/medical.svg";
import Messages from "../assets/Icons/messages.svg";
import MinusIcon from "../assets/Icons/minusIcon.svg";
import Notification from "../assets/Icons/notification.svg";
import Pcart from "../assets/Icons/Pcart.svg";
import Person from "../assets/Icons/person.svg";
import People from "../assets/Icons/people.svg";
import PhoneCall from "../assets/Icons/phone-call.svg";
import Phone from "../assets/Icons/phone.svg";
import PlusIcon from "../assets/Icons/plusIcon.svg";
import Pminus from "../assets/Icons/Pminus.svg";
import Pplus from "../assets/Icons/Pplus.svg";
import Refresh from "../assets/Icons/refresh.svg";
import RemoveMIcon from "../assets/Icons/remove-MIcon.svg";
import RightArrow from "../assets/Icons/right-arrow.svg";
import RightDoubleArrow from "../assets/Icons/right-double-arrow.svg";
import RocketMIcon from "../assets/Icons/rocket-MIcon.svg";
import Rupee from "../assets/Icons/rupee.svg";
import StreamlineSharpStarWhite from "../assets/Icons/streamline-sharp_star-white.svg";
import StreamlineSharpStar from "../assets/Icons/streamline-sharp_star.svg";
import StrengthGrid1 from "../assets/Icons/strength-grid-1.svg";
import StrengthGrid2 from "../assets/Icons/strength-grid-2.svg";
import StrengthGrid3 from "../assets/Icons/strength-grid-3.svg";
import StrengthGrid4 from "../assets/Icons/strength-grid-4.svg";
import SubtitleMIcon from "../assets/Icons/subtitle-MIcon.svg";
import Tap from "../assets/Icons/tap.svg";
import Tick from "../assets/Icons/tick.svg";
import Twitter from "../assets/Icons/twitter.svg";
import UpiLogo from "../assets/Icons/upi-logo.svg";
import Urgent from "../assets/Icons/urgent.svg";
import Verified from "../assets/Icons/verified.svg";
import VisaLogo from "../assets/Icons/visa-logo.svg";
import WhatsappLogo from "../assets/Icons/whatsapp-logo.svg";
import Whatsapp from "../assets/Icons/whatsapp.svg";
import Women from "../assets/Icons/women.svg";
import Temples from "../assets/Icons/temples.svg";
import Community from "../assets/Icons/community.svg";
import Youtube from "../assets/Icons/youtube.svg";
import GmailIcon from "../assets/Icons/gmailIcon.svg";
import WhatsappIcon from "../assets/Icons/whatsappIcon.svg";
import FacebookIcon from "../assets/Icons/facebookIcon.svg";
import XIcon from "../assets/Icons/xIcon.svg";
import LinkedinIcon from "../assets/Icons/linkedinIcon.svg";
import CloseIcon from "../assets/Icons/closeIcon.svg";
import PhonepayIcon from "../assets/Icons/phonepayIcon.svg";
import GpayIcon from "../assets/Icons/gpayIcon.svg";
import DonateOnceStar from "../assets/Icons/donate-once-star.svg";
import DonateMonthlySmile from "../assets/Icons/donate-monthly-smiley.svg";
import StatRaised from "../assets/Icons/stat-raised.svg";
import StatGoal from "../assets/Icons/stat-goal.svg";
import StatBackers from "../assets/Icons/stat-backers.svg";
import UpiIcon from "../assets/Icons/upiIcon.svg";
import MoreIcon from "../assets/Icons/moreIcon.svg";
import SuccessIcon from "../assets/Icons/successIcon.svg";
import WhiteTrash from "../assets/Icons/trash-white.svg";
import Search from "../assets/Icons/search.svg";
import Filter from "../assets/Icons/filter.svg";
import WhiteClose from "../assets/Icons/closeIcon-white.svg";
import Target from "../assets/Icons/target.svg";
import DashLinev from "../assets/Icons/dash-line-v.svg";
import DonateLeftIcon1 from "../assets/Icons/DonateLeftIcon1.svg";
import DonateLeftIcon2 from "../assets/Icons/DonateLeftIcon2.svg";
import DownArrow from "../assets/Icons/downArrow.svg";
import ThankyouSuccessIcon from "../assets/Icons/Success-Icon.svg";
import FailureIcon from "../assets/Icons/failure-icon.svg";
import ArrowDownWhite from "../assets/Icons/arrow-down-white.svg";
import ArrowUpWhite from "../assets/Icons/arrow-up-white.svg";
import HeartOrgan from "../assets/Icons/heart-organ.svg";
import Kidney from "../assets/Icons/kidney.svg";
import Newborn from "../assets/Icons/newborn.svg";
import Bones from "../assets/Icons/bones.svg";
import CancerRibbon from "../assets/Icons/cancer-ribbon.svg";
import Question from "../assets/Icons/question.svg";
import Feedback from "../assets/Icons/feedback.svg";
import Bag from "../assets/Icons/bag.svg";
import Opacity from "../assets/Icons/opacity.svg";
import GreenLightning from "../assets/Icons/GreenLightning.svg";
import GreenShop from "../assets/Icons/GreenShop.svg";
import GreenCalendar from "../assets/Icons/Green_calendar.svg";
import GreenBGTick from "../assets/Icons/GreenBG_Tick.svg";
import GreenBox from "../assets/Icons/Green_box.svg";
import GreenCamera from "../assets/Icons/Green_camera.svg";
import GreenVerified from "../assets/Icons/Green_verified.svg";
import GreenBill from "../assets/Icons/Green_bill.svg";
import Shop from "../assets/Icons/shop.svg";
import LocationPin from "../assets/Icons/location.svg";
import CardGoal from "../assets/Icons/card-goal.svg";
import CardRaised from "../assets/Icons/card-raised.svg";
import CardBackers from "../assets/Icons/card-backers.png";
import ProgressGoal from "../assets/Icons/progress-goal.png";
import ProgressRaised from "../assets/Icons/progress-raised.svg";
import ProgressBackers from "../assets/Icons/progress-backers.png";
import CatLeafDecor from "../assets/Elements/cat-leaf-decor.png";
import CatTopLeafDecor from "../assets/Elements/cat-top-leaf-decor.svg";
import CatUnionDecor from "../assets/Elements/cat-union-decor.svg";
import MonthlyHeartDecor from "../assets/Elements/monthly-heart-decor.svg";
import MonthlyVineDecor from "../assets/Elements/monthly-vine-decor.svg";

// Elements
import AboutBannerMask1 from "../assets/Elements/aboutBannerMask1.svg";
import AboutBannerMask2 from "../assets/Elements/aboutBannerMask2.svg";
import AboutBannerMask3 from "../assets/Elements/aboutBannerMask3.svg";
import AboutBannerMask4 from "../assets/Elements/aboutBannerMask4.svg";
import AboutBannerMask5 from "../assets/Elements/aboutBannerMask5.svg";
import AboutPink from "../assets/Elements/aboutPink.png";
import DonateMonthlyMask1 from "../assets/Elements/DonateMonthlyMask1.svg";
import DonateMonthlyMask2 from "../assets/Elements/DonateMonthlyMask2.svg";
import DonateMonthlyMask3 from "../assets/Elements/DonateMonthlyMask3.svg";
import GreenHand from "../assets/Elements/green-hand.svg";
import GreenRope from "../assets/Elements/green-rope.svg";
import Heart from "../assets/Elements/heart.svg";
import HeroSectionMask1 from "../assets/Elements/HeroSectionMask1.svg";
import HeroSectionMask2 from "../assets/Elements/HeroSectionMask2.svg";
import HeroSectionMask3 from "../assets/Elements/HeroSectionMask3.svg";
import HeroRing from "../assets/Elements/hero/hero-ring.svg";
import HeroBadgeBg from "../assets/Elements/hero/hero-badge-bg.svg";
import HeroFavoriteIcon from "../assets/Elements/hero/hero-favorite-icon.png";
import HeroHeartIcon from "../assets/Elements/hero/hero-heart-icon.png";
import HeroMeshBlob from "../assets/Elements/hero/hero-mesh-blob.svg";
import HeroMeshVector from "../assets/Elements/hero/hero-mesh-vector.svg";
import HeroBg from "../assets/Elements/hero/hero-bg.svg";
import HeroBgPng from "../assets/Elements/hero/hero-bg.png";
import MaskDesign from "../assets/Elements/MaskDesign.svg";
import MaskRedBox from "../assets/Elements/MaskRedBox.svg";
import MonthlyMaskDesign from "../assets/Elements/MonthlyMaskDesign.svg";
import OrangeSparks from "../assets/Elements/orange-sparks.svg";
import PinkCircles from "../assets/Elements/pink-circles.svg";
import PinkHearts from "../assets/Elements/pink-hearts.svg";
import PinkMask from "../assets/Elements/pink-mask.svg";
import PinkSplash from "../assets/Elements/pink-splash.svg";
import Quote from "../assets/Elements/quote.svg";
import RedHearts from "../assets/Elements/red-hearts.svg";
import RedOutlineHands from "../assets/Elements/red-outline-hands.svg";
import RequestFriend from "../assets/Elements/requestFriend.svg";
import StringHand from "../assets/Elements/string-hand.svg";
import WhiteHeart from "../assets/Elements/white-heart.svg";
import WhiteHearts from "../assets/Elements/white-hearts.svg";
import YellowHearts from "../assets/Elements/yellow-hearts.svg";
import requestFriendImgBg from "../assets/Elements/requestFriend.svg";
import WCUcalendar from "../assets/Icons/WCUcalendar.svg";
import WCUclock from "../assets/Icons/WCUclock.svg";
import WCUhappyemoji from "../assets/Icons/WCUhappyemoji.svg";
import WCUheart from "../assets/Icons/WCUheart.svg";
import WCUmoney from "../assets/Icons/WCUmoney.svg";
import WCUverify from "../assets/Icons/WCUverify.svg";
import DropdownArrow from "../assets/Icons/dropdown-arrow.svg";


// Images
import About21 from "../assets/Images/about-2-1.png";
import About22 from "../assets/Images/about-2-2.png";
import About23 from "../assets/Images/about-2-3.png";
import AboutBanner1 from "../assets/Images/about-banner-1.png";
import AboutBanner2 from "../assets/Images/about-banner-2.png";
import AboutBanner3 from "../assets/Images/about-banner-3.png";
import AboutBanner4 from "../assets/Images/about-banner-4.png";
import AboutBanner5 from "../assets/Images/about-banner-5.png";
import AboutMission from "../assets/Images/about-mission.png";
import AboutVision1 from "../assets/Images/about-vision1.png";
import AboutVision2 from "../assets/Images/about-vision2.png";
import AboutPinkBg from "../assets/Images/aboutPink-bg.png";
import AuthenticationLeftBg from "../assets/Images/authentication-left-bg.png";
import AuthenticationLeftImg from "../assets/Images/authentication-left-img.png";
import BackgroundStructure from "../assets/Images/BackgroundStructure.png";
import BetterIndia from "../assets/Images/better-india.png";
import BusinessToday from "../assets/Images/business-today.png";
import CampaignDetailBanner from "../assets/Images/CampaignDetailBanner.png";
import CampaignImg1 from "../assets/Images/CampaignImg1.png";
import CampaignImg2 from "../assets/Images/CampaignImg2.png";
import CampaignImg3 from "../assets/Images/CampaignImg3.png";
import Document from "../assets/Images/document.png";
import DonateMonthlyImage1 from "../assets/Images/DonateMonthlyImage1.png";
import DonateMonthlyImage2 from "../assets/Images/DonateMonthlyImage2.png";
import DonateMonthlyImage3 from "../assets/Images/DonateMonthlyImage3.png";
import MonthlyDonationCard1 from "../assets/Images/MonthlyDonationCard1.png";
import MonthlyDonationCard2 from "../assets/Images/MonthlyDonationCard2.png";
import MonthlyDonationCard3 from "../assets/Images/MonthlyDonationCard3.png";
import FoodKit1 from "../assets/Images/Food-Kit1.png";
import FoodKit2 from "../assets/Images/Food-Kit2.png";
import FoodKit3 from "../assets/Images/Food-Kit3.png";
import FoodKit4 from "../assets/Images/Food-Kit4.png";
import GirlMask from "../assets/Images/GirlMask.svg";
import GirlMaskTop from "../assets/Images/GirlMaskTop.svg";
import HeroMain1 from "../assets/Images/hero-main-1.png";
import HeroMain2 from "../assets/Images/hero-main-2.png";
import HeroMain3 from "../assets/Images/hero-main-3.png";
import HeroI1 from "../assets/Images/HeroI1.png";
import HeroI2 from "../assets/Images/HeroI2.png";
import HeroI3 from "../assets/Images/HeroI3.png";
import HindustanTimes from "../assets/Images/hindustan-times.png";
import IndiaToday from "../assets/Images/india-today.png";
import IndianExpress from "../assets/Images/indian-express.png";
import LiveDonationFeed from "../assets/Images/LiveDonationFeed.png";
import News18 from "../assets/Images/news18.png";
import OurImpact from "../assets/Images/OurImpact.png";
import ProjectImage1 from "../assets/Images/ProjectImage1.png";
import ProjectImage2 from "../assets/Images/ProjectImage2.png";
import ProjectImage3 from "../assets/Images/ProjectImage3.png";
import ProjectImage4 from "../assets/Images/ProjectImage4.png";
import RequestFriendImg from "../assets/Images/request-friend.png";
import StartNewCampaign from "../assets/Images/StartNewCampaign.png";
import StartNewCampaign2 from "../assets/Images/StartNewCampaign2.png";
import Updates from "../assets/Images/updates.png";
import YoutubeThumbnail from "../assets/Images/YoutubeThumbnail.svg";
import LoginLeftBg1 from "../assets/Images/login-left-bg1.png";
import LoginLeftBg2 from "../assets/Images/login-left-bg2.png";
import LoginLeftBg3 from "../assets/Images/login-left-bg3.png";
import LoginLeftBg4 from "../assets/Images/login-left-bg4.png";
import FallBackImageBanner from "../assets/Images/FallBackImageBanner.png";
import FallBackImageCard from "../assets/Images/FallBackImageCard.png";
import ProfileUser from "../assets/Icons/Profile-user.svg";
import ProfileCoin from "../assets/Icons/Profile-coin.svg";
import ProfileWalletMoney from "../assets/Icons/Profile-wallet-money.svg";
import ProfileCard from "../assets/Icons/Profile-card.svg";
import ProfileDocumentDownload from "../assets/Icons/Profile-document-download.svg";
import ProfileCrown from "../assets/Icons/Profile-crown.svg";
import ProfileLogout from "../assets/Icons/Profile-logout.svg";
import MoneyIcon from "../assets/Icons/chart.svg";
import ChartIcon from "../assets/Icons/moneys.svg";
import EditWhite from "../assets/Icons/edit-white.svg";
import ProfileIconCall from "../assets/Icons/profile-call.svg";
import ProfileIconBook from "../assets/Icons/profile-book.svg";
import ProfileIconCards from "../assets/Icons/profile-cards.svg";
import ProfileIconNote from "../assets/Icons/profile-note.svg";
import ProfileIconSex from "../assets/Icons/profile-sex.svg";
import ProfileIconSms from "../assets/Icons/profile-sms.svg";
import RequestForm from "../assets/Images/request-form.svg";
import MonthlyDonationDetail from "../assets/Images/MonthlyDonationDetail.png";
import MonthlyDonationDetailSlider1 from "../assets/Images/MonthlyDonationDetailSlider1.png";
import MonthlyDonationDetailSlider2 from "../assets/Images/MonthlyDonationDetailSlider2.png";
import MonthlyDonationDetailSlider3 from "../assets/Images/MonthlyDonationDetailSlider3.png";
import MonthlyDonationDetailSlider4 from "../assets/Images/MonthlyDonationDetailSlider4.png";
import Helpus1 from "../assets/Images/helpus1.png";
import Helpus2 from "../assets/Images/helpus2.png";
import Helpus3 from "../assets/Images/helpus3.png";
import Helpus4 from "../assets/Images/helpus4.png";
import Helpus5 from "../assets/Images/helpus5.png";
import DonateLeftBanner from "../assets/Images/donateLeftBanner.png";
import ThankyouBanner from "../assets/Images/thankyou-banner.png";
import FaqBanner from "../assets/Images/faq-banner.png";
import BlogDetail1 from "../assets/Images/blog-detail1.png";
import BlogDetail2 from "../assets/Images/blog-detail2.png";
import BlogDetail3 from "../assets/Images/blog-detail3.png";
import BlogDetail4 from "../assets/Images/blog-detail4.png";
import BannerPattern from "../assets/Images/sub-banner-pattern.png";
import CardProfile from "../assets/Images/card-profile.png";


// Action icons
import RedTrash from "../assets/Icons/Red-trash.svg";
import Eye from "../assets/Icons/eye.svg";

// Other assets
import FooterLogo from "../assets/footer-logo.svg";
import Logo from "../assets/logo.svg";
import ReactLogo from "../assets/react.svg";

export const Images = {
  // Icons
  aboutPeople: AboutPeople,
  americanExpressLogo: AmericanExpressLogo,
  animals: Animals,
  arrowUpRight: ArrowUpRight,
  box: Box,
  callMIcon: CallMIcon,
  children: Children,
  contactusFormElement: ContactusFormElement,
  creditCard: CreditCard,
  disability: Disability,
  disasterRelief: DisasterRelief,
  diy: Diy,
  edit: Edit,
  education: Education,
  elderly: Elderly,
  exploreMIcon: ExploreMIcon,
  eyeSlash: EyeSlash,
  facebook: Facebook,
  faith: Faith,
  footerFacebook: FooterFacebook,
  footerInstagram: FooterInstagram,
  footerLinkedin: FooterLinkedin,
  footerTwitter: FooterTwitter,
  gps: Gps,
  greenRupee: GreenRupee,
  healthInsuranceMIcon: HealthInsuranceMIcon,
  heartMIcon: HeartMIcon,
  homeMIcon: HomeMIcon,
  hospitalGrey: HospitalGrey,
  hospital: Hospital,
  hunger: Hunger,
  infoCircleMIcon: InfoCircleMIcon,
  layer: Layer,
  leftArrow: LeftArrow,
  leftDoubleArrow: LeftDoubleArrow,
  linkedin: Linkedin,
  loginMIcon: LoginMIcon,
  logoutMIcon: LogoutMIcon,
  mail: Mail,
  mastercardLogo: MastercardLogo,
  medical: Medical,
  messages: Messages,
  minusIcon: MinusIcon,
  notification: Notification,
  pcart: Pcart,
  person: Person,
  people: People,
  phoneCall: PhoneCall,
  phone: Phone,
  plusIcon: PlusIcon,
  pminus: Pminus,
  pplus: Pplus,
  refresh: Refresh,
  removeMIcon: RemoveMIcon,
  rightArrow: RightArrow,
  rightDoubleArrow: RightDoubleArrow,
  rocketMIcon: RocketMIcon,
  rupee: Rupee,
  streamlineSharpStarWhite: StreamlineSharpStarWhite,
  streamlineSharpStar: StreamlineSharpStar,
  strengthGrid1: StrengthGrid1,
  strengthGrid2: StrengthGrid2,
  strengthGrid3: StrengthGrid3,
  strengthGrid4: StrengthGrid4,
  subtitleMIcon: SubtitleMIcon,
  tap: Tap,
  tick: Tick,
  twitter: Twitter,
  upiLogo: UpiLogo,
  urgent: Urgent,
  verified: Verified,
  visaLogo: VisaLogo,
  whatsappLogo: WhatsappLogo,
  whatsapp: Whatsapp,
  women: Women,
  temples: Temples,
  community: Community,
  youtube: Youtube,
  gmailIcon: GmailIcon,
  whatsappIcon : WhatsappIcon,
  facebookIcon : FacebookIcon,
  xicon :XIcon,
  linkedinIcon : LinkedinIcon,
  closeIcon :CloseIcon,
  phonepayIcon :PhonepayIcon,
  gpayIcon :GpayIcon,
  donateOnceStar: DonateOnceStar,
  donateMonthlySmile: DonateMonthlySmile,
  statRaised: StatRaised,
  statGoal: StatGoal,
  statBackers: StatBackers,
  upiIcon : UpiIcon,
  moreIcon :MoreIcon,
  chartIcon :ChartIcon,
  moneyIcon : MoneyIcon,
  editWhite:EditWhite,
  profileIconSms:ProfileIconSms,
  profileIconSex:ProfileIconSex,
  profileIconNote:ProfileIconNote,
  profileIconCards:ProfileIconCards,
  profileIconBook:ProfileIconBook,
  profileIconCall:ProfileIconCall,
  successIcon :SuccessIcon,
  whiteTrash:WhiteTrash,
  search:Search,
  filter:Filter,
  whiteClose:WhiteClose,
  target:Target,
  dashLinev:DashLinev,
  donateLeftIcon1:DonateLeftIcon1,
    donateLeftIcon2:DonateLeftIcon2,
    downArrow:DownArrow,
    thankyouSuccessIcon:ThankyouSuccessIcon,
    failureIcon:FailureIcon,
    arrowDownWhite:ArrowDownWhite,
    arrowUpWhite:ArrowUpWhite,
    heartOrgan: HeartOrgan,
    kidney: Kidney,
    newborn: Newborn,
    bones: Bones,
    cancerRibbon: CancerRibbon,
    question: Question,
    feedback: Feedback,
    bag: Bag,
    opacity: Opacity,
    greenLightning: GreenLightning,
    greenShop: GreenShop,
    greenCalendar: GreenCalendar,
    greenBgTick: GreenBGTick,
    greenBox: GreenBox,
    greenCamera: GreenCamera,
    greenVerified: GreenVerified,
    greenBill: GreenBill,
    shop: Shop,
    locationPin: LocationPin,
    dropdownArrow:DropdownArrow,
    cardGoal: CardGoal,
    cardRaised: CardRaised,
    cardBackers: CardBackers,
    progressGoal: ProgressGoal,
    progressRaised: ProgressRaised,
    progressBackers: ProgressBackers,
    catLeafDecor: CatLeafDecor,
    catTopLeafDecor: CatTopLeafDecor,
    catUnionDecor: CatUnionDecor,
    monthlyHeartDecor: MonthlyHeartDecor,
    monthlyVineDecor: MonthlyVineDecor,

  // Elements
  aboutBannerMask1: AboutBannerMask1,
  aboutBannerMask2: AboutBannerMask2,
  aboutBannerMask3: AboutBannerMask3,
  aboutBannerMask4: AboutBannerMask4,
  aboutBannerMask5: AboutBannerMask5,
  aboutPink: AboutPink,
  donateMonthlyMask1: DonateMonthlyMask1,
  donateMonthlyMask2: DonateMonthlyMask2,
  donateMonthlyMask3: DonateMonthlyMask3,
  greenHand: GreenHand,
  greenRope: GreenRope,
  heart: Heart,
  heroSectionMask1: HeroSectionMask1,
  heroSectionMask2: HeroSectionMask2,
  heroSectionMask3: HeroSectionMask3,
  heroRing: HeroRing,
  heroBadgeBg: HeroBadgeBg,
  heroFavoriteIcon: HeroFavoriteIcon,
  heroHeartIcon: HeroHeartIcon,
  heroMeshBlob: HeroMeshBlob,
  heroMeshVector: HeroMeshVector,
  heroBg: HeroBg,
  heroBgPng: HeroBgPng,
  maskDesign: MaskDesign,
  maskRedBox: MaskRedBox,
  monthlyMaskDesign: MonthlyMaskDesign,
  orangeSparks: OrangeSparks,
  pinkCircles: PinkCircles,
  pinkHearts: PinkHearts,
  pinkMask: PinkMask,
  pinkSplash: PinkSplash,
  quote: Quote,
  redHearts: RedHearts,
  redOutlineHands: RedOutlineHands,
  requestFriend: RequestFriend,
  stringHand: StringHand,
  whiteHeart: WhiteHeart,
  whiteHearts: WhiteHearts,
  yellowHearts: YellowHearts,
  requestFriendImgBg: requestFriendImgBg,
  WCUcalendar: WCUcalendar,
  WCUclock: WCUclock,
  WCUhappyemoji: WCUhappyemoji,
  WCUheart: WCUheart,
  WCUmoney: WCUmoney,
  WCUverify: WCUverify,
  thankyouBanner: ThankyouBanner,




  // Images
  about21: About21,
  about22: About22,
  about23: About23,
  aboutBanner1: AboutBanner1,
  aboutBanner2: AboutBanner2,
  aboutBanner3: AboutBanner3,
  aboutBanner4: AboutBanner4,
  aboutBanner5: AboutBanner5,
  aboutMission: AboutMission,
  aboutVision1: AboutVision1,
  aboutVision2: AboutVision2,
  aboutPinkBg: AboutPinkBg,
  authenticationLeftBg: AuthenticationLeftBg,
  authenticationLeftImg: AuthenticationLeftImg,
  backgroundStructure: BackgroundStructure,
  betterIndia: BetterIndia,
  businessToday: BusinessToday,
  campaignDetailBanner: CampaignDetailBanner,
  campaignImg1: CampaignImg1,
  campaignImg2: CampaignImg2,
  campaignImg3: CampaignImg3,
  document: Document,
  donateMonthlyImage1: DonateMonthlyImage1,
  donateMonthlyImage2: DonateMonthlyImage2,
  donateMonthlyImage3: DonateMonthlyImage3,
  MonthlyDonationCard1: MonthlyDonationCard1,
  MonthlyDonationCard2: MonthlyDonationCard2,
  MonthlyDonationCard3: MonthlyDonationCard3,
  foodKit1: FoodKit1,
  foodKit2: FoodKit2,
  foodKit3: FoodKit3,
  foodKit4: FoodKit4,
  girlMask: GirlMask,
  girlMaskTop: GirlMaskTop,
  heroMain1: HeroMain1,
  heroMain2: HeroMain2,
  heroMain3: HeroMain3,
  heroI1: HeroI1,
  heroI2: HeroI2,
  heroI3: HeroI3,
  hindustanTimes: HindustanTimes,
  indiaToday: IndiaToday,
  indianExpress: IndianExpress,
  liveDonationFeed: LiveDonationFeed,
  news18: News18,
  ourImpact: OurImpact,
  projectImage1: ProjectImage1,
  projectImage2: ProjectImage2,
  projectImage3: ProjectImage3,
  projectImage4: ProjectImage4,
  requestFriendImg: RequestFriendImg,
  startNewCampaign: StartNewCampaign,
  startNewCampaign2: StartNewCampaign2,
  updates: Updates,
  youtubeThumbnail: YoutubeThumbnail,
  loginLeftBg1: LoginLeftBg1,
  loginLeftBg2: LoginLeftBg2,
  loginLeftBg3: LoginLeftBg3,
  loginLeftBg4: LoginLeftBg4,
  fallBackImageBanner: FallBackImageBanner,
  fallBackImageCard: FallBackImageCard,
  profileUser: ProfileUser,
  profileCoin: ProfileCoin,
  profileWalletMoney: ProfileWalletMoney,
  profileCard: ProfileCard,
  profileDocumentDownload: ProfileDocumentDownload,
  profileCrown: ProfileCrown,
  profileLogout: ProfileLogout,
  requestForm: RequestForm,
  monthlyDonationDetail:MonthlyDonationDetail,
  monthlyDonationDetailSlider1:MonthlyDonationDetailSlider1,
  monthlyDonationDetailSlider2:MonthlyDonationDetailSlider2,
  monthlyDonationDetailSlider3:MonthlyDonationDetailSlider3,
  monthlyDonationDetailSlider4:MonthlyDonationDetailSlider4,
  helpus2:Helpus2,
  helpus1:Helpus1,
  helpus3:Helpus3,
  helpus4:Helpus4,
  helpus5:Helpus5,
  donateLeftBanner:DonateLeftBanner,
  faqBanner:FaqBanner,
  blogDetail1:BlogDetail1,
  blogDetail2:BlogDetail2,
  blogDetail3:BlogDetail3,
  blogDetail4:BlogDetail4,
  bannerPattern:BannerPattern,
  cardProfile:CardProfile,


  // Action icons
  redTrash: RedTrash,
  eye: Eye,

  // Other assets
  footerLogo: FooterLogo,
  logo: Logo,
  reactLogo: ReactLogo,
};
